var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    {
      staticClass:
        "lpu-doctor-card-review d-flex align-start text-decoration-none",
      attrs: { href: _vm.href },
    },
    [
      _vm.withIcon
        ? _c("span", {
            staticClass:
              "ui-icon-message-circle ui-icon-fz-medium text-info--text mr-4 flex-shrink-0",
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "text-body-2 text-secondary--text" }, [
        _vm._v(_vm._s(_vm.text)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }